import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "submitButton"]

  connect() {
    // Initialize the controller
  }

  disconnect() {
    // Cleanup if needed
  }
}
